/**
 * QueryErrorState — egységes hiba-ág az office-felületek adat-lekéréseihez.
 *
 * A markup a meglévő admin-center mintát követi (DocumentsAuditPage `isError` ága),
 * nem új layout: piros keretes doboz + AlertTriangle + újrapróba-gomb.
 *
 * Az `onRetry` opcionális — ahol a hook nem ad `refetch`-et, a gomb nem renderelődik
 * (a felhasználó akkor is LÁT hibát, nem üres képernyőt).
 */

import { useTranslation } from '@kgc/i18n';
import { Button } from '@kgc/ui';
import { AlertTriangle } from 'lucide-react';

export interface QueryErrorStateProps {
  /** Opcionális újratöltés; ha nincs megadva, a gomb kimarad. */
  onRetry?: () => void;
  /** Felülírható üzenet-kulcs; alapértelmezés: `common.loadError`. */
  messageKey?: string;
}

export function QueryErrorState({ onRetry, messageKey }: QueryErrorStateProps) {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-lg border border-red-200 bg-red-50 py-8 dark:border-red-800 dark:bg-red-950/20"
    >
      <div className="flex items-center gap-2 text-red-700 dark:text-red-300">
        <AlertTriangle className="h-4 w-4" />
        <span className="text-sm font-medium">{t(messageKey ?? 'common.loadError')}</span>
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
